import { DELETE_BOOKING_START_REQUEST, DELETE_BOOKING_ERROR_REQUEST, DELETE_BOOKING_SUCCESS_REQUEST } from "../actions/deleteBooking"

const defaultState = {
    isRequesting: false,
    hasError: false,
    isSuccessful: false,
}

export const deleteBookingState = (state = defaultState, action) => {
    switch (action.type) {
        case DELETE_BOOKING_START_REQUEST: return { ...state, isRequesting: true, hasError: false, isSuccessful: false }
        case DELETE_BOOKING_ERROR_REQUEST: return { ...state, isRequesting: false, hasError: true, isSuccessful: false }
        case DELETE_BOOKING_SUCCESS_REQUEST: return { ...state, isRequesting: false, hasError: false, isSuccessful: true }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/deleteBooking.js